module.exports = __webpack_public_path__ + "media/img/auth/facebook2-c84a274f05086e45c213b53741af0ed8.svg";